/**
 * What is printed ACROSS every page, and why nobody types it.
 *
 * THE MARK IS DERIVED FROM THE RECORD, NOT AUTHORED. A watermark exists to stop a printout being
 * mistaken for the live procedure, and a mark somebody can type is a mark somebody can get wrong:
 * a draft carrying no watermark, or worse, an obsolete revision still carrying one that says
 * APPROVED because the person who revised it did not think to change the text. Deriving it from the
 * revision's state means it cannot go stale and cannot be forged, which is the same argument the
 * footer and the rendition furniture already make.
 *
 * THE RULE IS THE FOOTER'S, EXACTLY: show the state unless the revision is RELEASED. A released
 * revision IS the controlled version, so a mark across it would be noise on the one document that
 * does not need one -- and the PDF still carries the confidentiality line and the object number on
 * every page, because a printout of a released revision is an uncontrolled COPY of a controlled
 * document, which is a different claim and already made.
 *
 * MIRRORED IN document_rendition.py. A watermark that appeared on screen and not in the PDF people
 * sign would be exactly the wrong half to have.
 */

/** The watermark for a revision in this state, or null when it needs none. */
export function watermarkFor(status: string | null | undefined): string | null {
    const state = (status ?? "").trim();
    if (!state) return null;
    // SAME TEST AS DocumentFooter AND _page_furniture: released is the only state without a mark.
    if (state.toUpperCase() === "RELEASED") return null;
    return state.toUpperCase();
}
